import React from "react";
import { Spinner } from "../../../assets";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { createShop } from "../../../actions/shop";
import { Redirect } from "react-router-dom";
import { useState } from "react";
import { payloadToFormData } from "../../../helpers";

export default function FinishSectionLoading({ values }) {

	const [timedOut, setTimedOut] = useState(false);
	const { shop, user } = useSelector(state => ({ shop: state.shop, user: state.session.user }));

	const dispatch = useDispatch();

	useEffect(() => {
		const to = setTimeout(() => {
			setTimedOut(true);
		}, 2000);
		return () => {
			clearTimeout(to);
		}
	}, []);

	// Extract shopdata, excluding anything not for sending.
	const { userData, ...shopData } = values;

	useEffect(() => {
		if (user && !user.shop && !shop.id && !shop.creating && !shop.shopCreationError) {
			dispatch(createShop(payloadToFormData(shopData)));
		}
	}, [user, shop, shopData, shop.shopCreationError, dispatch]);

	if (user && user.shop && timedOut) return <Redirect to="/signup/finish/success" />

	return <div className="form-section finishSection">
		<div className="inner">
			{!shop.shopCreationError
				?
				(
					<div className="detailView text-center">
						<h2>Setting up..</h2>
						<br /><br />
						<Spinner size={100} />
					</div>
				) : (
					<div className="detailView text-center">
						<h2>Something went wrong.</h2>
						<div className="details">
							There was an error of some kind when we tried to set up your shop. Press the button to try again, and if the problem persists, <a href="mailto:be@orderabl.com">get in touch</a> with us.
						</div>
						<div className="error">{shop.shopCreationError}</div>
						<br /><br /><br />
						<button
							style={{ display: "inline-block", fontSize: "2rem" }}
							onClick={e => dispatch(createShop(payloadToFormData(shopData)))}
						>Try again</button>
					</div>
				)
			}
		</div>
	</div>
}